import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const Youtube = ({ width, height }) => (
  <SvgImg
    viewbox="0 0 512 512"
    title="icons / followus / youtube"
    width={width}
    height={height}
  >
    <g id="Youtube">
      <path d="M512,256c0,141.4-114.6,256-256,256C114.6,512,0,397.4,0,256C0,114.6,114.6,0,256,0   C397.4,0,512,114.6,512,256z" fill="#CD201F" />
      <g>
        <path d="M391.1,194.6c-2.3-19.9-7.1-25.7-10.5-28.4c-5.4-4.2-15.2-5.7-28.3-6.6c-21-1.4-56.7-2.3-95.2-2.3    c-38.6,0-74.2,0.8-95.2,2.3c-13.1,0.9-22.9,2.4-28.3,6.6c-3.4,2.7-8.1,8.5-10.5,28.4c-3.4,28.7-3.4,94.1,0,122.8    c2.4,19.9,7.1,25.7,10.5,28.4c5.4,4.2,15.2,5.7,28.3,6.6c21,1.4,56.6,2.3,95.2,2.3c38.6,0,74.2-0.9,95.2-2.3    c13.1-0.9,22.9-2.4,28.3-6.6c3.4-2.6,8.1-8.5,10.5-28.4C394.5,288.7,394.5,223.3,391.1,194.6z M224.1,298.9V213l82.4,42.9    L224.1,298.9z" fill="#FFFFFF" />
      </g>
    </g>
  </SvgImg>
);
Youtube.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
Youtube.defaultProps = {
  width: undefined,
  height: undefined,
};
export default Youtube;
